import { Trans } from '@lingui/react/macro';
import Icon from 'components/Icon';
import { IFeatureFlags } from 'data/tenant-config';
import { analyticsState } from 'state/analytics';
import { tenantConfig } from 'utils/tenant';
import { getCarConfiguratorUrls } from 'utils/ui/webconfigurator';

export type TMenuItemProps = {
  itemType: 'scc' | 'dcc';
};

export default function CarConfiguratorMenuItem({ itemType }: TMenuItemProps) {
  tenantConfig().useState();

  const urls = getCarConfiguratorUrls(itemType);

  const sendAnalytics = (itemName: 'scc' | 'dcc') => {
    analyticsState().setValues({ dealerToolUsed: itemName });
  };

  if (!tenantConfig().isAllowed(`selection${itemType.toUpperCase()}` as keyof IFeatureFlags) || !urls?.length)
    return false;

  return urls.length > 1 ? (
    <div className="flex items-center hover:text-neon-100" part={`dealer-tools-${itemType}`}>
      <span className="flex grow p-2">
        <span className="grow">
          {itemType === 'scc' ? (
            <Trans context="brand-specific">SCC</Trans>
          ) : (
            <Trans context="brand-specific">DCC</Trans>
          )}
        </span>
      </span>
      <span className="isolate inline-flex space-x-2 rounded-md shadow-sm">
        {urls.map((item) => (
          <a
            key={item.id as string}
            href={item.tokenizedUrl}
            target="_blank"
            type="button"
            className="relative inline-flex items-center rounded-md bg-white px-2 py-1 text-xs font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-neon-100 focus:z-10"
            rel="noreferrer"
          >
            {item.name ?? item.language}
          </a>
        ))}
      </span>
    </div>
  ) : (
    <a
      key={urls[0].id as string}
      href={urls[0].tokenizedUrl}
      onClick={() => sendAnalytics(itemType)}
      target="_blank"
      className="flex p-2 hover:text-neon-100"
      rel="noreferrer"
      data-testid={`dealer-tools-${itemType}`}
    >
      <span className="grow">
        {itemType === 'scc' ? <Trans context="brand-specific">SCC</Trans> : <Trans context="brand-specific">DCC</Trans>}
      </span>
      <Icon aria-hidden="true" className="ex3d-icon--chevron size-5" />
    </a>
  );
}
